module.exports = __webpack_public_path__ + "img/category.3d5d3086.svg";